<div class="container-fluid">
    <div class="row mt-5">
        <div class="col-12">
            <h1 class="text-center">Asian Breakout CrossTrend H1</h1>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <app-lista-pulsanti-mercati (mercatoSelezionato)="selMarket($event)"></app-lista-pulsanti-mercati>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-3 ">
            <div class="form-check">
                <input mdbCheckbox class="form-check-input" type="checkbox" [(ngModel)]="lottivar" id="flexCheckDefault"
                    (click)="ricalcola($event)" />
                <label class="form-check-label" for="flexCheckDefault">
                    Lotti variabili
                </label>
            </div>
        </div>
        <div class="col-3">
            <mdb-form-control>
                <mdb-select [(ngModel)]="tipoStorico" (valueChange)="cambiaStorico($event)" >
                    <mdb-option *ngFor="let sto of storico" [value]="sto.value">{{
                        sto.label
                        }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label">Tipo Storico</label>
            </mdb-form-control>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 600px; display: block;"></highcharts-chart>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-summary [ts]="ts"></app-trading-system-summary>
        </div>
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartWeek
                [titolo]="'Trading System Weekly'"></app-trading-system-grafico-weekly>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartBuy
                [titolo]="'Trading System Weekly Buy'"></app-trading-system-grafico-weekly>
        </div>
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartSell
                [titolo]="'Trading System Weekly Sell'"></app-trading-system-grafico-weekly>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <app-trading-system-grafico-weekly #chartMonth
                [titolo]="'Trading System Monthly'"></app-trading-system-grafico-weekly>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartMonthlyBuy
                [titolo]="'Trading System Monthly Buy'"></app-trading-system-grafico-weekly>
        </div>
        <div class="col-6">
            <app-trading-system-grafico-weekly #chartMonthlySell
                [titolo]="'Trading System Monthly Sell'"></app-trading-system-grafico-weekly>
        </div>
    </div>
</div>